<template>
  <div>
    <div v-if="infoList.length > 0" class="right_box">
      <div v-for="(it, i) in infoList" :key="i" @click="goDetail(it)">
        <!-- <img style="width: 25%;" v-if="it.thumb" :src="it.thumb" /> -->
        <div style="width: 100%">
          <div class="title single">{{ it.title }}</div>
          <div class="time">{{ it.date }}</div>
          <div class="article">
            {{ it.description }}
          </div>
        </div>
      </div>
      <Page
        v-if="infoList.length != 0"
        :current="params.pageNo"
        :page-size="params.pageSize"
        :total="total"
        class="common_page_box"
        show-total
        @on-change="changePage"
      ></Page>
    </div>
    <div v-if="infoList.length == 0" class="common_excel_no_more">
      暂无内容~
    </div>
  </div>
</template>

<script>
import { getArticle } from "@/api/home/index";
export default {
  props: {},
  data() {
    return {
      infoList: [],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 20,
      },
      catid: "",
      keywords: "",
    };
  },
  watch: {
    catid(val) {
      console.log("catid", val);
      this.params.pageNo = 1;
      const savedPage = sessionStorage.getItem("newsPage");
      if (savedPage) {
        this.params.pageNo = JSON.parse(savedPage).pageNo;
      }
      this.getArticle();
    },
    keywords(val) {
      this.getArticle();
    },
  },
  created() {
    const savedPage = sessionStorage.getItem("newsPage");
    if (savedPage) {
      this.params.pageNo = JSON.parse(savedPage).pageNo;
    }
  },
  methods: {
    init() {
      this.getArticle();
    },
    /* ====================数据请求部分========================== */
    getArticle() {
      getArticle({
        catid: this.catid,
        keywords: this.keywords,
        ...this.params,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.infoList = res.result.records;
          this.total = res.result.total;
        } else {
          this.infoList = [];
        }
      });
    },
    /* ====================页面交互部分========================== */
    changePage(e) {
      this.params.pageNo = e;
      this.getArticle();
    },
    goDetail(it) {
      console.log("locationList", this.locationList);
      this.$router.push({
        name: "news_detail",
        query: {
          id: it.id,
        },
        params: {
          locationList: encodeURIComponent(JSON.stringify(this.locationList)),
        },
      });
      sessionStorage.setItem(
        "newsPage",
        JSON.stringify({
          ...this.params,
          catid: this.catid,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.right_box {
  // width: 75%;

  > div {
    border-bottom: 1px solid #eee;
    padding: 10px;
    //padding-bottom: 30px;
    //margin-bottom: 30px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    -webkit-transition: all 0.2s ease-in;
    -moz-transition: all 0.2s ease-in;
    -o-transition: all 0.2s ease-in;
    display: flex;

    img {
      width: 250px;
      height: 180px;
      margin-right: 30px;
    }

    .title {
      font-size: 20px;
      color: #000000;
      text-align: left;
    }

    .time {
      color: #575b66;
      font-size: 15px;
      padding: 10px 0;
    }

    .article {
      color: #9e9e9e;
      font-size: 13px;
    }
  }

  > div:hover {
    // background-color: #eee;
    // padding: 15px 10px;
    box-shadow: 5px 5px 20px #9e9e9e;
  }
}
</style>
